import { useRoute } from "@react-navigation/native";
import React from "react";
import { Dimensions, Pressable, StyleSheet, View } from "react-native";
import Image from "@components/common/Image";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "@reducers/cartReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import analytics from "@services/analytics";
import entityStyle from "@utils/entityStyle";
import { SELF_ORDER_BANNER_ONLY } from "../../constants/analyticsEventsCT";

import handleCMSNavigation from "../../utils/handleCMSNavigation";

const { width } = Dimensions.get("window");

const SelfOrderBannerOnly = (props) => {
  const {
    link = "",
    link_type = "",
    cl_title = "",
    image_dimension_width = 360,
    image_dimension_height = 240,
    image_link = "",
  } = props;

  const aspectRatio = image_dimension_width / image_dimension_height;
  const imageHeight = width / aspectRatio;

  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }));

  const dispatch = useDispatch();
  const route = useRoute();

  const ctaLink = () => {
    analytics.trackEvent(SELF_ORDER_BANNER_ONLY.PLACE_ORDER, {
      screen: route?.name,
    });
    const payload = {
      user_id: user.user_id,
      user_name: "खुद के लिए",
    };

    dispatch(
      actions.viewCartLiteSuccess(
        { cartTotal: {}, result: [] },
        payload.user_id,
      ),
    );

    dispatch(actions.viewCartLiteRequest(payload));
    dispatch(customerActions.setSelectedContact(payload));
    handleCMSNavigation(link, link_type);
  };

  return (
    <View style={[entityStyle.entityContainer]}>
      <Pressable onPress={ctaLink}>
        <Image
          source={{ uri: image_link }}
          resizeMode={Image.resizeMode.contain}
          style={[
            styles.imageBackground,
            {
              height: imageHeight,
              overflow: "hidden",
            },
          ]}
        />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  imageBackground: {
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    overflow: "hidden",
  },
});

export default SelfOrderBannerOnly;
